import { call, put, takeEvery } from "redux-saga/effects"
import axios from "axios"
import actionTypes from "../constants/actionTypes"
import { API_BASE_URL } from "../constants/config"

// 사용자 정보 가져오기 API 호출
function* fetchUserInfo() {
    try {
        const token = localStorage.getItem("token")
        const config = {
            headers: {
                Authorization: `${token}`,
            },
        }

        const response = yield call(axios.get, `${API_BASE_URL}/waiting-user/member/me`, config)

        yield put({
            type: actionTypes.USER_INFO_FETCH_SUCCEED,
            payload: response.data,
        })
    } catch (error) {
        console.error("사용자 정보 가져오기 오류:", error)
        yield put({
            type: actionTypes.USER_INFO_FETCH_FAILED,
            payload: error.response?.data?.message || "사용자 정보를 가져오는데 실패했습니다.",
        })
    }
}

// 회원 정보 입력 API 호출
function* inputMemberInfo(action) {
    try {
        const token = localStorage.getItem("token")
        const config = {
            headers: {
                Authorization: `${token}`,
                "Content-Type": "application/json",
            },
        }

        // 백엔드가 기대하는 단순 구조로 데이터 구성
        const requestBody = {
            id: action.payload.id,
        }


        const response = yield call(axios.post, `${API_BASE_URL}/waiting-user/member/input`, requestBody, config)


        yield put({
            type: actionTypes.USER_INFO_INPUT_FETCH_SUCCEED,
            payload: response.data,
        })

        // 회원 정보 입력 성공 시 로그인 정보 승인 처리 (순환 호출 방지를 위해 제거)
        // yield put({
        //   type: actionTypes.LOGIN_INFO_APPROVAL,
        // })
    } catch (error) {
        console.error("회원 정보 입력 오류:", error)
        console.error("오류 응답:", error.response?.data)
        yield put({
            type: actionTypes.USER_INFO_INPUT_FETCH_FAILED,
            payload: error.response?.data?.message || "회원 정보 입력 중 오류가 발생했습니다.",
        })
    }
}

// Watcher saga
export default function* userSaga() {
    yield takeEvery(actionTypes.USER_INFO_FETCH, fetchUserInfo)
    yield takeEvery(actionTypes.USER_INFO_INPUT_FETCH, inputMemberInfo)
}
